import React, { useCallback, useState, useEffect } from 'react';
import { Space, Breadcrumb, Table, message, Row, Col, Button, Popconfirm, Spin } from 'antd';
import { CardLayout, TableWrapper, ProjectAskEditModal, ProjectAskNoteEditModal, FileViewerModal } from 'components/molecules';
import SearchBox from './SearchBox'
import { TotalNumMenu } from 'components/atoms';
import { useTableInfo, useProjectAsk } from 'hooks';
import { useLocation, useNavigate } from 'react-router';
import qs from 'query-string';
import { addNewSearch } from 'utils/utils';
import { ColumnsType } from 'antd/lib/table/interface';
import { INIT_PAGESIZE } from 'commons/constants';
import { usePopupManager } from 'react-popup-manager';
import axios from 'axios';
import { endpoints } from 'services';
import { SERVER_URL } from 'commons/constants';
import { DownloadOutlined, SearchOutlined } from '@ant-design/icons';
import { isFileViewer } from 'utils/file-utils';
import { fetcher } from 'services';
import * as XLSX from 'xlsx';

export interface  ProjectAskProps {}

const  ProjectAsk = ({}:  ProjectAskProps): React.ReactElement => {
  /* ======================================================
   * hooks
   * ====================================================== */
  const navigate = useNavigate();
  const location = useLocation();
  const { askList, searchResult, refetch, noteFileUpdate } = useProjectAsk();  
  const [isLoding, setIsLoading] = useState<boolean>(false);   

  /* ======================================================
   * variables
   * ====================================================== */
  const { open } = usePopupManager();
  const [rowExpaned, setRowExpaned] = useState<number[]>([]);  
  const searchParams = qs.parse(location.search);

   const onCellClick = (record) => {
    return {
      onClick: (e) => {
        open(ProjectAskEditModal, {id: Number(record.id), onClose: (isOk)=>{if(isOk) {refetch();}}});          
      },
    };
   };

  const columns: ColumnsType<ProjectAskListDto> = [
    {
      title: '번호',
      dataIndex: 'id',
      key: 'id',
      width: '70px',
      align: 'center',
      onCell: (record) => {
        return {
            onClick: (e) => {
              if (rowExpaned.includes(record.id)) {
                setRowExpaned(rowExpaned.filter(item => item !== record.id) ) 
              } else {
                setRowExpaned(preRowExpaned => [...preRowExpaned, record.id])
              }              
            },
        };
      },        
    },  
    {
      title: '일자',
      dataIndex: 'created_at',
      key: 'created_at',
      width: '160px',
      align: 'center',
      ellipsis: true,
      onCell: onCellClick,
    },      
    {
      title: '고객사',
      dataIndex: 'company_name',
      key: 'company_name',
      width: '150px',
      align: 'left', 
      ellipsis: true,  
      onCell: onCellClick,  
    },  
    {
      title: '강의구분',
      dataIndex: 'lecture_type1',
      key: 'lecture_type1',
      width: '120px',
      align: 'center',
      ellipsis: true,
      onCell: onCellClick,
    },
    {
      title: '강의주제',
      dataIndex: 'lecture_subject1',
      key: 'lecture_subject1',
      width: '120px',
      align: 'center',
      ellipsis: true,
      onCell: onCellClick,
    },  
    {
      title: '기본대응',
      dataIndex: 'pm',
      key: 'pm',
      width: '50px',
      align: 'center',
      ellipsis: true,
      onCell: onCellClick,
    },     
    {
      title: 'F/U',
      dataIndex: 'pm2',
      key: 'pm2',
      width: '50px',
      align: 'center',
      ellipsis: true,
      onCell: onCellClick,
    },               
    {
     title: '고객담당자',
     dataIndex: 'crm_name',
     key: 'crm_name',
     width: '120px',
     align: 'center',
     ellipsis: true,
     onCell: onCellClick,
   },   
   {
    title: '담당자 연락처',
    dataIndex: 'crm_phone',
    key: 'crm_phone',
    width: '120px',
    align: 'center',
    ellipsis: true,
    onCell: onCellClick,
  }, 
  {
    title: '담당자 이메일',
    dataIndex: 'crm_mail',
    key: 'crm_mail',
    width: '150px',
    align: 'center',
    ellipsis: true,
    onCell: onCellClick,
  },    
  {
    title: '인지경로',
    dataIndex: 'how_know',
    key: 'how_know',
    width: '150px',
    align: 'center',
    ellipsis: true,
    onCell: onCellClick,
  },   
    {
      title: '미팅',
      key: 'metting',
      width: '80px',
      align: 'center',
      render: (record) => {
        return (
          <>
            <a onClick={(e) => {
              if (rowExpaned.includes(record.id)) {
                setRowExpaned(rowExpaned.filter(item => item !== record.id) ) 
              } else {
                setRowExpaned(preRowExpaned => [...preRowExpaned, record.id])
              }
            }}>{record.notes.length}건</a>&nbsp;|&nbsp;
            <a onClick={(e) => {
              onNoteEditPopup(record.id, 0, record.company_name, record.crm_name + ' / ' + record.crm_mail + ' / ' + record.crm_phone);
            }}>등록</a>
          </>
        )
      }
    },
    {
      title: '진행여부',
      dataIndex: 'checkYn',
      key: 'checkYn',
      width: '60px',
      align: 'center',
      render: (checkYn, record) => {
        return (
          <Popconfirm
            title="진행여부 상태를 변경 하시겠습니까?"
            okText="변경"
            cancelText="취소"
            onConfirm={(e) => {
              fetcher.project.postProjectAskUpdateCheck({
                id: record.id,
                checkYn: checkYn==='Y'?'N':'Y',
              })
              .then((res) => {
                  switch (res.code) {
                      case 200:
                          refetch();
                      break;
                      default:  
                      break;
                  };
              }); 
            }}
            >   
              <Button
                type='default'
              >{checkYn}</Button>
          </Popconfirm>

        )
      }  
    },  
  ];
  /* ======================================================
   * events
   * ====================================================== */    
  const onClickRegister = () => {
      open(ProjectAskEditModal, {id: 0, onClose: (isOk)=>{if(isOk) {refetch();}}}); 
   }
  
   const onChangePageInfo = (pageNo: number, pageSize: number) => {
     navigate({
       ...location,
       search: addNewSearch(location.search, { pageNo, pageSize }),
     });
   };  
  
   const onExcelDownload = () => {
    setIsLoading(true); 
    fetcher.project.postProjectAskList({
      pageNo: 1,
      pageSize: 0,
      searchValue: searchParams.search ? String(searchParams.search) : '',  
      searchDateStart: searchParams.searchDateStart ? String(searchParams.searchDateStart) : '',   
      searchDateEnd: searchParams.searchDateEnd ? String(searchParams.searchDateEnd) : '',  
      biz: searchParams.biz ? String(searchParams.biz) : '',  
      pm: searchParams.pm ? String(searchParams.pm) : '',  
      status: searchParams.status ? String(searchParams.status) : '',  
      lecture_type: searchParams.lecture_type ? String(searchParams.lecture_type) : '',  
      lecture_subject: searchParams.lecture_subject ? String(searchParams.lecture_subject) : '', 
    })
    .then((res) => {
        switch (res.code) {
            case 200:
            if (!!res.result) {
              const book = XLSX.utils.book_new();
              const nurses = XLSX.utils.json_to_sheet(
                res.result.list.map((item, index) => {
                  return {
                    '번호' : item.id,
                    '일자' : item.created_at,
                    '고객사': item.company_name,
                    '강의구분': item.lecture_type1,
                    '강의주제': item.lecture_subject1,
                    '사업부서': item.business_part,
                    '기본대응': item.pm,
                    'F/U': item.pm2,
                    '고객담당자': item.crm_name,
                    '담당자 연락처': item.crm_phone,
                    '담당자 이메일': item.crm_mail,
                    '인지경로': item.how_know,
                    '진행여부': item.checkYn,
                  }
                }), 
                { 
                  header : [
                    '번호',
                    '일자',
                    '고객사',
                    '강의구분',
                    '강의주제',
                    '사업부서',
                    '기본대응',
                    'F/U',
                    '고객담당자',
                    '담당자 연락처',
                    '담당자 이메일',
                    '인지경로',
                    '진행여부',
                  ], 
                  skipHeader : false 
                } 
              );
          
              nurses["!cols"] = [
                { wpx : 60 } 
              , { wpx : 120 } 
              , { wpx : 120 }  
              , { wpx : 120 }  
              , { wpx : 120 } 
              , { wpx : 120 } 
              , { wpx : 120 } 
              , { wpx : 120 } 
              , { wpx : 120 } 
              , { wpx : 120 } 
              , { wpx : 150 } 
              , { wpx : 200 } 
              , { wpx : 100 } 
              ]
          
              XLSX.utils.book_append_sheet( book, nurses, "NURSES" );
          
              XLSX.writeFile( book, "b2b_문의.xlsx" ); 
            }
            break;
            default:  
            break;
        };
        setIsLoading(false);         
    }); 
   }  
   
   const onDownload = (fileSeq:number, fileName: string): void => {
    axios({
      url: SERVER_URL + endpoints.file.download + '?file_id=' + fileSeq,
      method: 'get',
      responseType: 'blob',
    })
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
      })
      .catch(() => {
        message.error('파일 다운로드 중 에러가 발생했습니다.', 1);
      });
    };

    const onOpenFileViewer = (fileId: number, fileName: string, seq: number, gubun: string, editable: boolean) => {
      open(FileViewerModal, {
        fileid: fileId,
        filename: fileName,
        seq: seq,
        gubun: gubun,
        editable: editable,
        onClose: (isOk, seq, gubun, files) => {
          if (isOk) {
            if (gubun === 'note') {
              noteFileUpdate({
                id: seq,
                metting_note_fileData: files,
              }) 
            }
          };
        },
      });   
     }      

     const onNoteEditPopup = (group_id: number, id: number, company: string, crm: string) => {
      open(ProjectAskNoteEditModal, {
        id: id,
        ask_group_srl: group_id,      
        company,
        crm,
        onDownload: onDownload,
        onFilePreview: onOpenFileViewer,
        onClose: (isOk) => {
          if (isOk) {
            refetch();
          }
        },
      }); 
     }     
  /* ======================================================
   * hooks
   * ====================================================== */
  const { pagination, onTableChange } = useTableInfo({
    pageInfo: {
      pageNo: Number(searchParams.pageNo) || 1,
      pageSize: Number(searchParams.pageSize) || INIT_PAGESIZE,
    },
    datas: askList,
    totalCount: searchResult.totalCount,
    onChangePageInfo,
  });


  useEffect(() => {
    setRowExpaned([]);
  }, [searchResult.pageNo]);  

  const onExpaned = (val: boolean) => {
    if (val) {
      if (!!askList) {
        const rows: any[] = [];
        askList.forEach(record => {
          rows.push(record.id);
        })
        setRowExpaned(rows);
      }
    } else {
      setRowExpaned([]);
    }
  };

  /* ======================================================
   * render items
   * ====================================================== */
  return (
    <CardLayout title={(
      <Breadcrumb>
        <Breadcrumb.Item>Home</Breadcrumb.Item>
        <Breadcrumb.Item>B2B</Breadcrumb.Item>
        <Breadcrumb.Item>문의</Breadcrumb.Item>
    </Breadcrumb>      
    )}>
        <Space direction="vertical" style={{ width: '100%' }}>
          <SearchBox />
          <Spin spinning={isLoding} tip="처리중입니다. 잠시만 기다려 주세요." size="large">
            <TotalNumMenu onExpaned={onExpaned} totalNum={searchResult.totalCount} useRegister useExcelDownload onUseRegister={onClickRegister} onDownloadExcel={onExcelDownload}/>
            <TableWrapper isSearch={!!searchParams.search || !!searchParams.lecturer_type || !!searchParams.lecturer_category}>
              <Table
                tableLayout="fixed"
                dataSource={askList}
                columns={columns}
                pagination={pagination}
                onChange={onTableChange}
                style={{ width: '100%', overflowX: 'auto', minWidth: 600 }}
                className="columnCenterFixTable clickable"
                showSorterTooltip={false}
                rowKey={'id'}
                expandable={{
                  expandedRowRender: (record) => (
                    <Space direction="vertical" style={{padding:"5px 30px", width:"100%"}} size={3}>
                    {record.notes.map((item)=>(                    
                    <>
                      <div style={{display:"flex", alignItems:"center", justifyContent:"space-between"}}>
                        <a onClick={()=> onNoteEditPopup(record.id, item.id, record.company_name, record.crm_name + ' / ' + record.crm_mail + ' / ' + record.crm_phone)}>• {item.metting_date} [{item.metting_type==='ONLINE'?'유선미팅':'외부미팅'}] {item.title}</a>
                      </div>
                      <div key={item.id} style={{backgroundColor:"#f3f3f3"}}>
                        <hr style={{color:"#eeeeee"}}/>
                        <Row style={{padding:"5px"}}>
                          <Col flex="100px" style={{display:"flex", justifyContent:"center"}}>
                            미팅 내용
                          </Col>
                          <Col>
                            <pre style={{margin:"0px"}}>{item.memo}</pre>
                          </Col>
                        </Row>         
                        <Row style={{padding:"5px"}}>
                          <Col flex="100px" style={{display:"flex", justifyContent:"center"}}>
                            첨부 파일
                          </Col>
                          <Col>
                            {(item.metting_note_file_id>0) && (
                              <Space key={item.metting_note_file_id}>
                                {item.metting_note_file_name}                              
                                <Button onClick={()=>{onDownload(item.metting_note_file_id, item.metting_note_file_name)}} shape="round" icon={<DownloadOutlined />} size='small' style={{padding:'0px 3px'}}/>
                                {isFileViewer(item.metting_note_file_name) && (<Button onClick={()=>{onOpenFileViewer(item.metting_note_file_id, item.metting_note_file_name, record.id, 'note', false)}} shape="round" icon={<SearchOutlined />} size='small' style={{padding:'0px 3px'}}/>)}                                   
                              </Space>
                            )}
                          </Col>
                        </Row>  
                        <Row style={{padding:"5px"}}>
                          <Col flex="100px" style={{display:"flex", justifyContent:"center"}}>
                            제안 경로
                          </Col>
                          <Col>
                            {item.propose_url}
                          </Col>
                        </Row>                                                             
                        <hr style={{color:"#eeeeee"}} />
                      </div>                     
                    </>
                    ))}
                    </Space>
                  ),
                  columnWidth: 25,
                  expandedRowKeys: rowExpaned,
                  onExpand: (expaned, record) => { 
                    if (expaned) {
                      setRowExpaned(preRowExpaned => [...preRowExpaned, record.id])
                    } else {
                      setRowExpaned(rowExpaned.filter(item => item !== record.id) ) 
                    }
                  },                
                }}
              />
            </TableWrapper> 
          </Spin>
        </Space>                
    </CardLayout>
  )
};

export default  ProjectAsk;    